import React, { createContext, useContext, useState, useCallback } from "react";
import "../assets/styles/Notificacao.css";

const NotificacaoContext = createContext();

export function NotificacaoProvider({ children }) {
  const [mensagem, setMensagem] = useState("");
  const [tipo, setTipo] = useState("success");
  const [visivel, setVisivel] = useState(false);

  const mostrarNotificacao = useCallback((texto, tipo) => {
    setMensagem(texto);
    setTipo(tipo);
    setVisivel(true);
    setTimeout(() => setVisivel(false), 2000);
  }, []);

  return (
    <NotificacaoContext.Provider value={{ mostrarNotificacao }}>
      {children}
      {visivel && <div className={`notificacao notificacao--${tipo}`}>{mensagem}</div>}
    </NotificacaoContext.Provider>
  );
}

export function useNotificacao() {
  return useContext(NotificacaoContext);
}
